import { FC, memo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components'
import { Table } from 'ui/components/Table'

import { DeviceTableProps } from './DeviceTable.types'
import { columns } from './columns'

export const DeviceTable: FC<DeviceTableProps> = memo((props) => {
  const { onDelete, onSetDefault, dataSource, loading } = props

  return (
    <Layer rounded shadowed>
      <Table
        dataSource={dataSource}
        loading={loading}
        columns={columns(onDelete, onSetDefault)}
        dataQa={TableDataQa.MFA_DEVICES}
      />
    </Layer>
  )
})
